import type { DirectiveBinding } from 'vue'

/* eslint-disable unused-imports/no-unused-vars */
export default defineNuxtPlugin(({ vueApp }) => {
  function handleScroll(viewed: any, binding?: DirectiveBinding<any>) {
    const app = document.getElementById('__nuxt')
    if (!app || !viewed)
      return

    if (document) {
      const offset = app?.offsetHeight
      const { offsetHeight } = viewed
      if (!viewed?.classList?.contains('not-visible') && !viewed?.classList?.contains('already-visible'))
        viewed?.classList?.add('not-visible')
      else if (viewed?.classList?.contains('already-visible') && viewed?.classList?.contains('not-visible'))
        viewed?.classList?.remove('not-visible')

      const el = viewed?.getBoundingClientRect()
      const visible = offset > -offsetHeight * 0.2
        && el.bottom
        < (window.innerHeight || document.documentElement.clientHeight)
        + offsetHeight * 0.2

      if (visible && !viewed?.classList?.contains('already-visible')) {
        viewed?.classList?.add('already-visible')
        viewed?.classList?.remove('not-visible')
        // binding.def.unbind(el, binding)
      }
    }
  }
  vueApp.directive('scrolled', {
    mounted(el, binding) {
      if (window && typeof window !== 'undefined')
        window.addEventListener('scroll', () => handleScroll(el, binding))
        // alert('works') // client = browser only !
    },
  })
})
